import { number } from "prop-types";
import { useState, useCallback } from "react";
import { Auth } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";

export function useAddExternalPlugin(props) {
  const { makeAuthedRequest, hasPermission } = Auth.useContainer();
  const { logError } = useLogger({ prefix: "useAddExternal Plugin" });

  const [isWaiting, setIsWaiting] = useState(false);
  const [iboNumber, setIboNumber] = useState();
  const [losAwardId, setLosAwardId] = useState();
  const [sponsor, setSponsor] = useState();
  const [platinum, setPlatinum] = useState();
  const [emerald, setEmerald] = useState();
  const [diamond, setDiamond] = useState();
  const [wwgSignoff, setWwgSignoff] = useState();
  const [uplineSignoff, setUplineSignoff] = useState();
  const [notes, setNotes] = useState("");
  const [dateAdded, setDateAdded] = useState();
  const [lastReviewed, setLastReviewed] = useState();

  const submit = useCallback(async () => {
    setIsWaiting(true);

    const plugin = JSON.stringify({
      iboNumber: Number(iboNumber),
      losAwardId: Number(1),
      sponsor: Number(sponsor),
      platinum: Number(platinum),
      emerald: Number(emerald),
      diamond: Number(diamond),
      wwgSignoff: wwgSignoff,
      uplineSignoff: uplineSignoff,
      notes: notes,
      dateAdded: dateAdded,
      lastReviewed: lastReviewed,
    });

    const canCreate = hasPermission("membership.loa.plugins.create");
    if (canCreate && iboNumber) {
      return makeAuthedRequest(`/v1/membership/loa/external/${iboNumber}`, {
        method: "Put",
        body: plugin,
      })
        .then(async (res) => {
          if (res.ok) {
            return res.json();
          } else {
            const json = await res.json();
            throw new Error(json.message);
          }
        })
        .catch(logError)
        .finally(() => {
          setIsWaiting(false);
          props.onClose();
          props.refresh();
        });
    }
  }, [
    logError,
    hasPermission,
    makeAuthedRequest,
    sponsor,
    platinum,
    emerald,
    diamond,
    wwgSignoff,
    uplineSignoff,
    notes,
    dateAdded,
    lastReviewed,
    iboNumber,
    props,
  ]);

  return {
    submit,
    isWaiting,

    iboNumber,
    setIboNumber,

    losAwardId,
    setLosAwardId,

    sponsor,
    setSponsor,

    platinum,
    setPlatinum,

    emerald,
    setEmerald,

    diamond,
    setDiamond,

    wwgSignoff,
    setWwgSignoff,

    uplineSignoff,
    setUplineSignoff,

    notes,
    setNotes,
  };
}
